// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_encode from "../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";

function blockNode(blockNodes) {
  return {
          TAG: /* BlockNode */0,
          _0: {
            component: /* Div */0,
            payload: Json_encode.object_(/* [] */0),
            nodes: blockNodes
          }
        };
}

function blockInlineNode(nodes) {
  return {
          TAG: /* BlockInlineNode */1,
          _0: {
            component: /* Span */1,
            payload: Json_encode.object_(/* [] */0),
            nodes: nodes
          }
        };
}

function blockLeafNode(leaves) {
  return {
          TAG: /* BlockLeafNode */2,
          _0: {
            component: /* Span */1,
            payload: Json_encode.object_(/* [] */0),
            leaves: leaves
          }
        };
}

function inlineSpan(nodes) {
  return {
          TAG: /* InlineNode */0,
          _0: {
            component: /* Span */1,
            payload: Json_encode.object_(/* [] */0),
            nodes: nodes
          }
        };
}

function inlineText(leaves) {
  return {
          TAG: /* LeafNode */1,
          _0: {
            component: /* Span */1,
            payload: Json_encode.object_(/* [] */0),
            leaves: leaves
          }
        };
}

function text(text$1, markNodes) {
  return /* TextNode */{
          _0: {
            text: text$1,
            marks: markNodes
          }
        };
}

function headingOneNode(blockNodes, className) {
  return {
          TAG: /* BlockNode */0,
          _0: {
            component: /* HeadingOne */2,
            payload: Json_encode.object_({
                  hd: [
                    "className",
                    className
                  ],
                  tl: /* [] */0
                }),
            nodes: blockNodes
          }
        };
}

function headingTwoNode(blockNodes, className) {
  return {
          TAG: /* BlockNode */0,
          _0: {
            component: /* HeadingTwo */3,
            payload: Json_encode.object_({
                  hd: [
                    "className",
                    className
                  ],
                  tl: /* [] */0
                }),
            nodes: blockNodes
          }
        };
}

function mark(component, payload) {
  return {
          component: component,
          payload: payload
        };
}

function blockNodeStyleClassName(nodes, className) {
  return {
          TAG: /* BlockNode */0,
          _0: {
            component: /* CustomBlock */{
              _0: /* BlockStyleClassName */8
            },
            payload: Json_encode.object_({
                  hd: [
                    "className",
                    className
                  ],
                  tl: /* [] */0
                }),
            nodes: nodes
          }
        };
}

function inlineNodeStyleClassName(nodes, className) {
  return {
          TAG: /* InlineNode */0,
          _0: {
            component: /* CustomInline */{
              _0: /* InlineStyleClassName */1
            },
            payload: Json_encode.object_({
                  hd: [
                    "className",
                    className
                  ],
                  tl: /* [] */0
                }),
            nodes: nodes
          }
        };
}

function shuffleBlockChildren(blockNodes) {
  return {
          TAG: /* BlockNode */0,
          _0: {
            component: /* CustomBlock */{
              _0: /* ShuffleBlockChildren */19
            },
            payload: Json_encode.object_(/* [] */0),
            nodes: blockNodes
          }
        };
}

function showAnswerWrapper(blockNodes, questionIndex) {
  return {
          TAG: /* BlockNode */0,
          _0: {
            component: /* CustomBlock */{
              _0: /* ShowAnswerWrapper */21
            },
            payload: Json_encode.object_({
                  hd: [
                    "questionIndex",
                    questionIndex
                  ],
                  tl: /* [] */0
                }),
            nodes: blockNodes
          }
        };
}

function inlineImageNode(src) {
  return {
          TAG: /* InlineNode */0,
          _0: {
            component: /* Image */0,
            payload: Json_encode.object_({
                  hd: [
                    "src",
                    src
                  ],
                  tl: /* [] */0
                }),
            nodes: []
          }
        };
}

function blockInlineImageNode(src) {
  return {
          TAG: /* BlockInlineNode */1,
          _0: {
            component: /* Image */0,
            payload: Json_encode.object_({
                  hd: [
                    "src",
                    src
                  ],
                  tl: /* [] */0
                }),
            nodes: []
          }
        };
}

var Make = {
  blockNode: blockNode,
  blockInlineNode: blockInlineNode,
  blockLeafNode: blockLeafNode,
  inlineSpan: inlineSpan,
  inlineText: inlineText,
  text: text,
  headingOneNode: headingOneNode,
  headingTwoNode: headingTwoNode,
  mark: mark,
  blockNodeStyleClassName: blockNodeStyleClassName,
  inlineNodeStyleClassName: inlineNodeStyleClassName,
  shuffleBlockChildren: shuffleBlockChildren,
  showAnswerWrapper: showAnswerWrapper,
  inlineImageNode: inlineImageNode,
  blockInlineImageNode: blockInlineImageNode
};

export {
  Make ,
  
}
/* No side effect */
